import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'

const MainContainer = tw.div`
  z-1000
  top-96
  w-full
  pt-32
  h-72
  min-h-72
`

const Container = tw.div`
  flex
  max-w-960
  mx-auto
  relative
`

const TwText = tw.div`
  pl-24
  h-40
  text-26
  font-semibold
  leading-10

  text-primary
  overflow-hidden
  whitespace-nowrap
  overflow-ellipsis
  cursor-default
`

const TwPlaceholder = tw.div`
  pl-24
  h-40
  text-26
  font-semibold
  leading-10

  text-placeholder
  overflow-hidden
  whitespace-nowrap
  overflow-ellipsis
  cursor-default
`

export const TaskTitleInput = observer(({hub}: {hub: Hub}) => {
  const title = hub?.data?.taskTemplate?.title ?? ''

  const content = title ? (
    <TwText>{title}</TwText>
  ) : (
    <TwPlaceholder>{Lang.msg.taskTemplates.descTitlePlaceholder}</TwPlaceholder>
  )

  return (
    <MainContainer>
      <Container>{content}</Container>
    </MainContainer>
  )
})
